module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    staticClass: "form-control",
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "remote-method": _vm.searchCustomer,
      "placeholder": "Selectionnez un client / prospect"
    },
    model: {
      value: (_vm.customer_id),
      callback: function($$v) {
        _vm.customer_id = $$v
      },
      expression: "customer_id"
    }
  }, _vm._l((_vm.customers), function(customer) {
    return _c('customer', {
      key: customer.id,
      attrs: {
        "item": customer,
        "present": "option"
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b3964ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Entities/Selects/CustomerSelect.vue
// module id = 707
// module chunks = 1